export default __webpack_public_path__ + "static/media/downloadIcon.994fe8e6.svg";